var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BaseTable',_vm._g(_vm._b({ref:"datasetTable",attrs:{"options":_vm.options,"columns":_vm.columns,"showAllItems":true,"filterEnabled":false},on:{"loaded":_vm.onLoaded}},'BaseTable',_vm.$props,false),_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }